import { addYears } from 'date-fns/addYears';
import { endOfMonth } from 'date-fns/endOfMonth';
import { endOfWeek } from 'date-fns/endOfWeek';
import { endOfYear } from 'date-fns/endOfYear';
import { startOfDay } from 'date-fns/startOfDay';
import { startOfMonth } from 'date-fns/startOfMonth';
import { startOfWeek } from 'date-fns/startOfWeek';
import { startOfYear } from 'date-fns/startOfYear';
import { subDays } from 'date-fns/subDays';
import { subYears } from 'date-fns/subYears';

export enum TaskRangePreset {
  last7Days = 'last_7_days',
  today = 'today',
  thisWeek = 'this_week',
  thisMonth = 'this_month',
  thisYear = 'this_year',
  all = 'all',
  custom = 'custom',
}

export interface ITaskRange {
  from: Date;
  to: Date;
}

export function todayRange(now = new Date()): ITaskRange {
  const today = startOfDay(now);

  return { from: today, to: today };
}

export function rangeForPreset(
  preset: string,
  now = new Date(),
): ITaskRange | undefined {
  const today = startOfDay(now);

  switch (preset) {
    case TaskRangePreset.last7Days:
      return { from: subDays(today, 6), to: today };
    case TaskRangePreset.today:
      return todayRange(now);
    case TaskRangePreset.thisWeek:
      return {
        from: startOfWeek(today, { weekStartsOn: 1 }),
        to: startOfDay(endOfWeek(today, { weekStartsOn: 1 })),
      };
    case TaskRangePreset.thisMonth:
      return { from: startOfMonth(today), to: startOfDay(endOfMonth(today)) };
    case TaskRangePreset.thisYear:
      return { from: startOfYear(today), to: startOfDay(endOfYear(today)) };
    case TaskRangePreset.all:
      return { from: subYears(today, 1), to: addYears(today, 1) };
    default:
      return undefined;
  }
}
